import {Component, EventEmitter, HostBinding, Inject, NgZone, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {RouterService} from "@biletix/core/services/router.service";
import { APP_BASE_HREF, isPlatformBrowser } from '@angular/common';
import {ShoppingCartState} from "@biletix/core/models/state/shopping-cart-state.model";
import {ShoppingCart} from "@biletix/core/models/shopping-cart/shopping-cart.model";
import {PerformancePageStateService} from "@biletix/features/performance/services/performance-page-state.service";
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {animationFrameScheduler, fromEvent, Observable, of} from "rxjs";
import {auditTime, map} from "rxjs/operators";
import { Router } from '@angular/router';
import { CartTimeoutService } from '@biletix/core/services/cart-timeout.service';
import { CityService } from '@biletix/core/services/city.service';
import { City } from '@biletix/core/models/city.model';
import { environment } from '@biletix/env';
import { MatDialog } from '@angular/material/dialog';
import { BtxDateRangePickerDialogComponent } from '../../../components/date-range-picker-dialog/date-range-picker-dialog.component';

@Component({
  standalone: false,
  selector: 'btx-wide-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class WideHeaderComponent extends AbstractionComponent implements OnInit {

  private readonly searchBaseUrl = environment.search.baseUrl;

  @Output() public sidenavToggle = new EventEmitter();
  ticketCount$: Observable<number> = of(0);
  shoppingCartState?: ShoppingCartState;
  menuIconPath: string;
  cities: City[] = [];
  selectedCity: string = '-1';
  selectedDate: string = '-1';
  selectedCategory: string = '-1';

  customStartDate: Date | null = null;
  customEndDate: Date | null = null;
  previousDateSelection: string = '-1';
  //cartStateValue: boolean = false;

  /**
   * Mobil uygulama modu (.mobile-app-mode) — anasayfa header'ı:
   * host `is-homepage` sınıfıyla sticky yapılır (SCSS), aşağı kaydırınca `filters-collapsed`
   * ile arama kutusunun altındaki filtre şeridi (.category-filter-bar) katlanır, yukarı
   * kaydırınca açılır. Sınıflar web/masaüstünde de yazılır ama karşılık gelen CSS yalnızca
   * `.mobile-app-mode` altında olduğu için oradaki görünüm değişmez.
   */
  @HostBinding('class.filters-collapsed') filtersCollapsed = false;
  @HostBinding('class.is-homepage') get hostIsHomepage(): boolean { return this.isHomepage(); }

  /** Bu kadar aşağı inilince şerit katlanır (px) */
  private static readonly FILTERS_COLLAPSE_AFTER_PX = 80;
  /** Yukarı yönde bu kadar hareket edilince şerit açılır (px) — eşikte titremeyi önleyen histerezis */
  private static readonly FILTERS_EXPAND_UP_PX = 30;
  /** Bu noktanın üstünde her zaman açık */
  private static readonly FILTERS_TOP_RESET_PX = 10;
  private lastScrollY = 0;
  private scrolledUpDistance = 0;

  constructor(
    private routerService: RouterService,
    private performancePageStateService: PerformancePageStateService,
    private cartTimeoutService: CartTimeoutService,
    private ticketSaleService: TicketSaleService,
    private router: Router,
    private cityService: CityService,
    @Inject(APP_BASE_HREF) private baseHref: string,
    private dialog: MatDialog,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object) {
    super();
    this.menuIconPath = `${this.baseHref}assets/images/icon/menu.svg`;

    // router.events.subscribe((val) => {
    //   // see also
    //   this.changeCartState();
    // });
  }



  ngOnInit(): void {
    this.watchScrollForFilterCollapse();

    // this.performancePageStateService
    //         .shoppingCartStateChange
    //         .pipe(this.takeUntilDestroy())
    //         .subscribe(cart => {
    //           console.log("Header cart state changed");
    //           this.shoppingCartState = cart
    //         });

    this.cartTimeoutService
    .shoppingCartStateChange
    .pipe(this.takeUntilDestroy())
    .subscribe(shoppingCartState =>{
        this.shoppingCartState =shoppingCartState;
    });

    this.ticketCount$ = this.ticketSaleService
            .watchShoppingCart.pipe(this.takeUntilDestroy())
            .pipe(map((cart: ShoppingCart) => cart?.totalTicket ?? 0));

    this.cityService.getActiveCities()
      .pipe(this.takeUntilDestroy())
      .subscribe(cities => {
        this.cities = cities;
      });
  }

  get hasIframe(): boolean {
    const adDiv = document.getElementById('div-gpt-ad-1594640818191-0');
    if (!adDiv) return false;
    return adDiv.querySelector('iframe') !== null;
  }

  discover() {
    const regionAndLanguagePath = this.routerService.regionLanguagePath;
    const queryParams: string[] = [];

    if (this.selectedCategory !== '-1') {
      queryParams.push(`maincategory=${encodeURIComponent(this.selectedCategory)}`);
    }
    if (this.selectedCity !== '-1') {
      queryParams.push(`city=${encodeURIComponent(this.selectedCity)}`);
    }
    if (this.selectedDate !== '-1') {
      if (this.selectedDate === 'daterange' && this.customStartDate && this.customEndDate) {
        queryParams.push(`gt=${this.formatIsoDate(this.customStartDate)}`);
        queryParams.push(`lt=${this.formatIsoDate(this.customEndDate)}`);
      } else {
        queryParams.push(`date=${encodeURIComponent(this.selectedDate)}`);
      }
    }

    let url = this.searchBaseUrl + regionAndLanguagePath;
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    window.location.href = url;
  }

  getDateLabel(value: string): string {
    switch (value) {
      case '-1': return 'home.labels.allDates';
      case 'today': return 'home.labels.today';
      case 'weekend': return 'home.labels.weekend';
      case 'nextweekend': return 'home.labels.nextWeekend';
      case 'thisweek': return 'home.labels.thisWeek';
      case 'next14days': return 'home.labels.next14Days';
      case 'next30days': return 'home.labels.next30Days';
      case 'daterange': return 'home.labels.dateRange';
      default: return '';
    }
  }

  onDateChange(event: any): void {
    if (event.value === 'daterange') {
      const dialogRef = this.dialog.open(BtxDateRangePickerDialogComponent, {
        width: '95vw',
        maxWidth: '780px',
        panelClass: 'custom-datepicker-dialog-panel',
        data: {
          startDate: this.customStartDate,
          endDate: this.customEndDate
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.startDate && result.endDate) {
          this.customStartDate = result.startDate;
          this.customEndDate = result.endDate;
          this.selectedDate = 'daterange';
          this.previousDateSelection = 'daterange';
        } else {
          // If cancelled, revert to the previous selection
          this.selectedDate = this.previousDateSelection;
        }
      });
    } else {
      this.previousDateSelection = event.value;
      this.customStartDate = null;
      this.customEndDate = null;
    }
  }

  isCustomRange(): boolean {
    return this.selectedDate === 'daterange' && this.customStartDate !== null && this.customEndDate !== null;
  }

  isHomepage(): boolean {
    const urlPath = this.router.url.split('?')[0].split('#')[0];
    return urlPath === '/' || urlPath === '/anasayfa' || urlPath.startsWith('/anasayfa/');
  }

  /**
   * Sayfa (window) scroll'unu Angular zone dışında, kare başına en fazla bir kez dinler;
   * yalnızca katlanma durumu değişince zone'a girip change detection tetikler.
   * Sadece tarayıcıda ve sadece mobil uygulama modunda (sınıf <html>/<body>'de) çalışır —
   * eski app sürümleri sınıfı sayfa yüklendikten sonra body'ye eklediği için kontrol her
   * olayda yapılır, başlangıçta değil.
   */
  private watchScrollForFilterCollapse(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'scroll', {passive: true})
        .pipe(auditTime(0, animationFrameScheduler), this.takeUntilDestroy())
        .subscribe(() => {
          if (!this.isMobileAppMode() || !this.isHomepage()) {
            return;
          }
          const next = this.nextFiltersCollapsed(window.scrollY);
          if (next !== this.filtersCollapsed) {
            this.ngZone.run(() => this.filtersCollapsed = next);
          }
        });
    });
  }

  private isMobileAppMode(): boolean {
    return document.documentElement.classList.contains('mobile-app-mode')
      || document.body.classList.contains('mobile-app-mode');
  }

  /** Aşağı: eşiği geçince kapan. Yukarı: FILTERS_EXPAND_UP_PX birikince ya da en üste dönünce aç. */
  private nextFiltersCollapsed(scrollY: number): boolean {
    const delta = scrollY - this.lastScrollY;
    this.lastScrollY = scrollY;

    if (scrollY <= WideHeaderComponent.FILTERS_TOP_RESET_PX) {
      this.scrolledUpDistance = 0;
      return false;
    }
    if (delta > 0) {
      this.scrolledUpDistance = 0;
      return scrollY > WideHeaderComponent.FILTERS_COLLAPSE_AFTER_PX ? true : this.filtersCollapsed;
    }
    if (delta < 0) {
      this.scrolledUpDistance += -delta;
      if (this.scrolledUpDistance >= WideHeaderComponent.FILTERS_EXPAND_UP_PX) {
        return false;
      }
    }
    return this.filtersCollapsed;
  }

  getFormattedRange(): string {
    if (this.customStartDate && this.customEndDate) {
      const startDay = String(this.customStartDate.getDate()).padStart(2, '0');
      const startMonth = String(this.customStartDate.getMonth() + 1).padStart(2, '0');
      const startYear = this.customStartDate.getFullYear();

      const endDay = String(this.customEndDate.getDate()).padStart(2, '0');
      const endMonth = String(this.customEndDate.getMonth() + 1).padStart(2, '0');
      const endYear = this.customEndDate.getFullYear();

      if (startYear === endYear) {
        return `${startDay}.${startMonth} - ${endDay}.${endMonth}.${endYear}`;
      }
      return `${startDay}.${startMonth}.${startYear} - ${endDay}.${endMonth}.${endYear}`;
    }
    return '';
  }

  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  formatUrlDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  formatIsoDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  getCategoryLabel(value: string): string {
    switch (value) {
      case '-1': return 'home.labels.allCategories';
      case 'MUSIC': return 'home.labels.categoryMusic';
      case 'SPORT': return 'home.labels.categorySport';
      case 'ART': return 'home.labels.categoryArt';
      case 'FAMILY': return 'home.labels.categoryFamily';
      case 'OTHER': return 'home.labels.categoryOther';
      default: return '';
    }
  }

  // changeCartState(){
  //   if (this.router.url.indexOf('/cart') > -1) {
  //     this.cartStateValue = true;
  //   }else{
  //     this.cartStateValue = false;
  //   }
  // }

  showTimerInHeader(){
    //const isMobile = this.getIsMobile();
    const isExistShoppingCart =this.isExistShoppingCart();
    const isCartPage =this.isCartPage();
    const isOrderSummaryExists =this.isOrderSummaryExists();

    //return !isMobile && isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;
    return isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;

  }

  isOrderSummaryExists(){
    return this.shoppingCartState && this.shoppingCartState.isNotEmpty();
  }

  isCartPage() {
    return this.router.url.indexOf('/cart') > -1;
  }


  isExistShoppingCart(): boolean {
      return this.ticketSaleService.isExistShoppingCart();
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }

  ngAfterViewInit(): void{

  }

}
